const NumberSkeleton = () => {
    return (
        <span className="text-gray-400 animate-pulse">--</span>

      
    );
  };
  
  export default NumberSkeleton